import BaseFormM from './BaseFormM.vue';

BaseFormM.install = function (Vue) {
  Vue.component(BaseFormM.name, BaseFormM);
};

export default BaseFormM;
